import { render } from "./KeyboardKeysInfo.vue?vue&type=template&id=1ebf59e2"
import script from "./KeyboardKeysInfo.vue?vue&type=script&lang=js"
export * from "./KeyboardKeysInfo.vue?vue&type=script&lang=js"

import "./KeyboardKeysInfo.vue?vue&type=style&index=0&id=1ebf59e2&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__